// import ScrollMagic from 'scrollmagic'
import ModulesLoader from './js/modules-loader.js'

window.addEventListener('load', function (event) {
  window.modulesLoader = new ModulesLoader()
  window.modulesLoader.loadModules()
  // window.animationScenes(new ScrollMagic.Controller())
})
